export default "__VITE_PUBLIC_ASSET__217c45a6__"